import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 10 minutes 23 seconds
  const [timeLeft, setTimeLeft] = useState(10 * 60 + 23);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="bg-[#dc2626] text-white py-1.5 px-4 sticky top-0 z-50" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm font-medium" data-id="element-2">
        <span data-id="element-3">⏳</span>
        <span data-id="element-4">OFERTA EXPIRA EN:</span>
        <span className="bg-white text-[#dc2626] px-2 py-0.5 rounded font-mono font-bold" data-id="element-5">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}